module.exports = __webpack_public_path__ + "static/Infographic4_5_Tainan_mobile-d04248ea322bbbc8af1e51e28fc0ec2b.png";